export type ShiftsPresentation = 'calendar' | 'table';

/**
 * Decides which presentation `/shifts` renders.
 *
 * Without v3 the page stays the table it has always been, and no toggle is
 * offered. Under v3 the calendar becomes the default, but a link that names a
 * specific shift still opens the table: Phoebe has already sent Slack cards,
 * emails, and SMS short links built by `get_shift_dashboard_url`, and those
 * point at `/shifts?shiftId=…`. They must keep landing where they always did.
 *
 * An explicit `?presentation=` always wins, so a user who toggles to the
 * calendar while a shift is selected stays on the calendar.
 */
export function resolveShiftsPresentation({
    presentation,
    agentV3Enabled,
    hasShiftDeepLink,
}: {
    readonly presentation: ShiftsPresentation | undefined;
    readonly agentV3Enabled: boolean;
    readonly hasShiftDeepLink: boolean;
}): ShiftsPresentation {
    if (!agentV3Enabled) {
        return 'table';
    }
    if (presentation !== undefined) {
        return presentation;
    }
    return hasShiftDeepLink ? 'table' : 'calendar';
}

export function isShiftsPresentation(
    value: unknown,
): value is ShiftsPresentation {
    return value === 'calendar' || value === 'table';
}
